import { render, staticRenderFns } from "./changelog-subscriber.vue?vue&type=template&id=ca5f8d32"
import script from "./changelog-subscriber.vue?vue&type=script&lang=js"
export * from "./changelog-subscriber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports